// 全局组件自动注册
import Vue from "vue"; // html文件头已引入Vue，无需再引入

// https://webpack.js.org/guides/dependency-management/#require-context
const requireComponent = require.context(
  // 其组件目录的相对路径
  "./",
  // 是否查询其子目录
  true,
  // 匹配基础组件文件名的正则表达式 这里查index.vue即可
  /index.vue$/
);

// For each matching file name...
requireComponent.keys().forEach((fileName) => {
  // Get the component config
  const componentConfig = requireComponent(fileName);

  // 全局注册组件
  Vue.component(
    componentConfig.default.name,
    componentConfig.default || componentConfig
  );
});
